import React from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeRaw from 'rehype-raw';
import rehypeKatex from 'rehype-katex';
import CodeBlock from '../codeblock/CodeBlock';
import 'katex/dist/katex.min.css';

interface MarkdownLaTeXRendererProps {
  content: string;
}

const MarkdownLaTeXRenderer: React.FC<MarkdownLaTeXRendererProps> = ({ content }) => {

  // Korrigierte Ersetzung von \( \) -> $ ... $ und \[ \] -> $$ ... $$
  const processedText = content
    ?.replace(/\\\[/g, '$$')
    .replace(/\\\]/g, '$$')
    .replace(/\\\(/g, '$')
    .replace(/\\\)/g, '$') ?? '';

  const remarkMathOptions = {
    singleDollarTextMath: true, // Erlaubt $...$ für Inline-Mathe
  };

  return (
    <ReactMarkdown
      components={{
        code({ inline, className, children, ...props }: { inline?: boolean; className?: string; children: React.ReactNode }) {
          const match = /language-(\w+)/.exec(className || '');
          return !inline && match ? (
            <CodeBlock
              language={match[1]}
              value={String(children).trim()}
            />
          ) : (
            <code className={className} {...props}>
              {children}
            </code>
          );
        }
      } as Components}
      children={processedText}
      remarkPlugins={[[remarkMath, remarkMathOptions], remarkGfm]}
      rehypePlugins={[rehypeRaw, rehypeKatex]}
    />
  );
};

export default MarkdownLaTeXRenderer;